import { Checkbox } from "@mantine/core";
import type { DateTime } from "luxon";
import { DateInput } from "../../../../mantine/dates/DateInput/DateInput";
import { luxonDateTimeToBackendDateOrDateTime } from "../../../../utils/dates/luxonDateTimeToBackendDateOrDateTime";
import "./TodoDueDateCell.scss";

type TodoDueDateCellProps = {
  dueDate?: DateTime | undefined;
  overdue: boolean;
  onChangeDueDate: (todoId: number, dueDate: string | null) => void;
  onChangeOverdue: (todoId: number, overdue: boolean) => void;
  todoId: number;
  notChangeable?: boolean;
};

function TodoDueDateCell({
  onChangeDueDate,
  onChangeOverdue,
  dueDate,
  overdue,
  todoId,
  notChangeable
}: TodoDueDateCellProps) {
  return (
    <div className="todo-due-date-cell-container">
      {notChangeable ? (
        <div>
          {overdue
            ? "Überfällig"
            : dueDate
              ? luxonDateTimeToBackendDateOrDateTime(dueDate)
              : ""}
        </div>
      ) : (
        <>
          <DateInput
            className="todo-due-date-cell-datepicker"
            disabled={overdue}
            id={"todo-due-date-cell-datepicker" + todoId}
            value={dueDate}
            onChange={(date) => {
              if (date) {
                onChangeDueDate(
                  todoId,
                  luxonDateTimeToBackendDateOrDateTime(date)
                );
              }
            }}
          />
          <Checkbox
            checked={overdue}
            label="Überfällig"
            ml="xl"
            onChange={() => onChangeOverdue(todoId, !overdue)}
          />
        </>
      )}
    </div>
  );
}

export { TodoDueDateCell };
